import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
    selector: 'app-formly-repeat-section-multiple-fields',
    styles: [
        `
      .formly-repeat {
        justify-content: space-between;
      }
      .formly-repeat-remove-button-container {
        margin-top: 10px;
        float: right;
      }
      .formly-repeat-section_field {
        display: flex;
        align-items: center;
        gap: 10px;

        ::ng-deep .ng-star-inserted {
          flex: 1;
        }
      }
      .button-container {
        display: flex;
        gap: 10px;
        margin-bottom: 35px;
      }
      .button-container + .warning {
        margin-top: 10px;
      }
    `,
    ],
    template: `
    <div
      *ngFor="let field of field.fieldGroup; let i = index"
      class="formly-repeat">
      <div class="formly-repeat-remove-button-container">
        <su-button
          [skin]="'secondary'"
          (onClick)="remove(i)"
          [icon]="'remove'"
          [matTooltip]="props?.tooltipForRemove"
          [ariaLabel]="props?.tooltipForRemove">
        </su-button>
      </div>
      <formly-field
        [id]="field.key + '_' + i.toString()"
        [field]="field"
        class="formly-repeat-section_field"></formly-field>
    </div>
    <div class="button-container">
      <su-button
        [skin]="'accent'"
        [icon]="'add'"
        (onClick)="add()"
        #tooltip="matTooltip"
        [matTooltip]="field.props?.tooltip"
        [disabled]="
          !(!props?.maxItems || props?.maxItems > field.fieldGroup!.length)
        "
        [label]="props?.addText"></su-button>
    </div>
    <p
      class="warning"
      color="warn"
      *ngIf="!(!props?.maxItems || props?.maxItems > field.fieldGroup!.length)"
      [innerText]="
        props?.maxWarningMessage | translate: { max: props?.maxItems }
      "></p>
  `,
    standalone: false
})
export class RepeatMultipleFieldsTypeComponent extends FieldArrayType {
  override add() {
    super.add();
    setTimeout(() => {
      const lastIndex = this.field.fieldGroup.length - 1;
      const field = document.getElementById(`${lastIndex}_${lastIndex}`);
      if (field) {
        const producerInput = field.querySelector(
          '[id*="producer"]'
        ) as HTMLInputElement;

        if (producerInput) {
          producerInput.focus();
        }
      }
    }, 0);
  }
}
